export const routes = {
  home: '/',
  perfumes: '/perfumes',
  tecnologia: '/tecnologia',
  joyeria: '/joyeria',
  cart: '/cart', // Ruta dedicada para el carrito
  productDetail: '/product/:id',
  privacy: '/politica-de-privacidad',
  warranty: '/politica-de-garantia',
  search: '/search',
  registro: '/registro',
  login: '/login',
  misPedidos: '/mis-pedidos',     // 👈 nuevo
  miCuenta: '/mi-cuenta',       // 👈 nuevo
};